import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Divider, IconButton, Typography } from '@mui/material'
import React from 'react'

interface IProps {
    title: string
    children?: React.ReactNode
    isExpanded: boolean
    onToggle: () => void
}

export const CustomAccordion: React.FC<IProps> = ({ title, children, isExpanded, onToggle }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: isExpanded ? 1 : 0, minHeight: 0 }}>
            <Divider />
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderBottom: 'none',
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: isExpanded ? 1 : 0,
                    minHeight: 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        mt: 1,
                        flexShrink: 0,
                    }}
                    onClick={onToggle}
                >
                    <Typography
                        variant="h5"
                        color="secondary"
                        sx={{
                            flex: 1,
                            textAlign: 'center',
                            marginLeft: '32px',
                        }}
                    >
                        {title}
                    </Typography>
                    <IconButton size="small" color="secondary" sx={{ marginLeft: 1 }}>
                        {isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                </Box>

                <Box
                    sx={{
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: isExpanded ? 1 : 0,
                        minHeight: isExpanded ? 0 : '50px',
                        maxHeight: isExpanded ? undefined : '50px',
                        height: isExpanded ? undefined : '50px',
                        div: {
                            overflow: isExpanded ? '' : 'initial',
                        },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    )
}
